import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AdvancedFilteringByFileUsersDialogComponent} from './advanced.filtering.by.file.users.dialog.component';

const routes =
    [{path: 'advancedfilteringbyfileusersdialog', component: AdvancedFilteringByFileUsersDialogComponent}];

@NgModule({
  declarations: [AdvancedFilteringByFileUsersDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AdvancedFilteringByFileUsersDialogComponent]
})

export class AdvancedFilteringByFileUsersModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/advanced.filtering/advanced.filtering.by.file.users.dialog.module.ts